/** @format */

import {HourglassTopOutlined} from '@mui/icons-material';

import {useTheme} from '@mui/material/styles';

import {Badge, BadgeBox, HeaderBox, RegularText, DescriptionBox} from './styles';
import {HotspotKey} from '../../../../types';
import StarImg from './images/family-star.svg?react';
import StarShineImg from './images/star-shine.svg?react';

interface Props {
  daysLeft: number;
  hotspotKey: HotspotKey;
}

const RenderAlertComponent = ({daysLeft, hotspotKey}: Props) => {
  const theme = useTheme();

  if (hotspotKey === 'sensors') {
    return (
      <>
        <HeaderBox customColor={theme.palette.semantic_light?.primary.main}>
          <StarImg />
          Простой способ <br />
          повысить пользу
          <br />
          сенсоров
        </HeaderBox>

        <DescriptionBox>
          <RegularText>
            Мы распределили сенсоры по важности, но у вас могут быть другие задачи.
          </RegularText>
          <RegularText>
            Выберите именно те сенсоры, которые будут полезны вашему проекту.
          </RegularText>
        </DescriptionBox>

        <Badge>
          <StarShineImg />
          Вы так же можете тонко настроить конкретный сенсор, чтобы исключить ложные срабатывания
        </Badge>
      </>
    );
  }

  const renderMediaplanBadges = () => {
    return (
      <BadgeBox>
        <Badge>
          Отслеживание
          <br />
          план/факта по бюджету
        </Badge>
        <Badge>
          KPI: план/факт
          <br />и аномалии показателей
        </Badge>
        <Badge>
          Прогноз расхода и KPI
          <br />
          на конец периода
        </Badge>
        <Badge>
          Статистика KPI
          <br />
          на уровне кампаний
        </Badge>
      </BadgeBox>
    );
  };

  switch (daysLeft) {
    case 2:
      return (
        <>
          <HeaderBox customColor={theme.palette.semantic_light?.alert.main}>
            <HourglassTopOutlined />
            Настройте, пока
            <br />
            триал не закончился
          </HeaderBox>

          <RegularText>Медиаплан необходим, чтобы получить больше пользы</RegularText>

          {renderMediaplanBadges()}
        </>
      );
    case 1:
      return (
        <>
          <HeaderBox customColor={theme.palette.semantic_light?.alert.main}>
            <HourglassTopOutlined />
            Триал
            <br />
            почти закончился,
            <br />а вы еще многого
            <br />
            не увидели
          </HeaderBox>

          <RegularText>Успейте настроить, чтобы получить больше пользы</RegularText>

          {renderMediaplanBadges()}
        </>
      );
    default:
      return null;
  }
};

export {RenderAlertComponent};
